import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import SavedFilters from "./SavedFilters";
import Table from "../ErrorTab/Table";
import heartLoading from "../../assests/heartLoading.gif";

const SavedErrorDetails = ({
  dashboardId,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialLoaded = useRef(false);

  useEffect(() => {
    if (!dashboardId) return;

    setLoading(true);

    axios
      .get(`${BASE_URL}/error-details-view/${dashboardId}?page=${page}&page_size=10`)
      .then((res) => {
        setData(res.data);

        // Apply saved values only first time
        if (!initialLoaded.current) {
          if (res.data.filters) onFiltersChange(res.data.filters);
          if (res.data.search_term) onSearchChange(res.data.search_term);
          initialLoaded.current = true;
        }
      })
      .catch((err) => console.error("Error fetching saved error details:", err))
      .finally(() => setLoading(false));
  }, [dashboardId, page]);

  if (!data || loading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center w-full h-full">
        <img src={heartLoading} alt="loading" style={{ width : 200}}/>
      </div>
    );
  }

  return (
    <div className="error-detailss">

      {/* Only show already saved filters */}
      <SavedFilters savedFilters={data.filters} />

      <Table
        tableData={data.tableData}
        pagination={data.pagination}
        errorPreviews={data.errorPreviews}
        onPageChange={setPage}
      />
    </div>
  );
};

export default SavedErrorDetails;
